export default function (
  rawInfo: RawCreditCardPaymentInformation,
): CreditCardPaymentInformation {
  return {
    minAmount: rawInfo.MinAmount || null,
    minPercent: rawInfo.MinPercent || null,
  };
}
